import axios from "axios";
const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

// Normalize FastAPI/axios error into a readable string
export function errMessage(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(", ") || fallback;
  if (typeof d === "object") return d?.msg || JSON.stringify(d);
  return fallback;
}

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const trackLead = (id, mobile) => api.get(`/leads/${id}`, { params: { mobile } }).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const submitCallback = (payload) => api.post("/callback", payload).then((r) => r.data);
export const submitPartnership = (payload) => api.post("/partnership", payload).then((r) => r.data);
export const checkEligibility = (payload) => api.post("/eligibility", payload).then((r) => r.data);
export const listBlog = (category) => api.get("/blog", { params: category ? { category } : {} }).then((r) => r.data);
export const blogCategories = () => api.get("/blog/categories").then((r) => r.data);
export const getPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
